export const url = {
    home: () => "/",

    catalog: () => "/shop/catalog",

    category: (category) => `/shop/catalog/${category.slug}`,

    product: (product) => `/shop/products/${product.url_key}`,
};

export function getCategoryParents(category) {
    return category.parent ? [...getCategoryParents(category.parent), category.parent] : [];
}
